// TODO: Make this prod key
const env = process.env.NODE_ENV;
const sKey = (env === "test") ? "sk_test_2twpcVhV9pHGucPwSvPjcj16" : "sk_live_UG0Bkw6GGTJ3BvrSW8doWnfM";
const stripe = require("stripe")(sKey);

export { stripe };
